export const STRIPE_STATUS = {
  ACTIVE: 'active',
  ON_GRACE_PERIOD: 'onGracePeriod',
  PAST_DUE: 'past_due'
}
export const STRIPE_CATEGORY = {
  WEBSITE: 'website',
  LOCAL_PRESENCE: 'local_presence'
}
